import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useLocation, useHistory } from "react-router-dom";
import { makeStyles, Button } from '@material-ui/core';
import { Sync, ExitToApp } from '@material-ui/icons';
import { useTranslation } from "react-i18next";

import { VENUE_IMPORTER_URL, PROFILE_URL } from '../../const/URL.const';
import { useSquareAuth } from '../../hooks/useSquareExternal';
import SquareLocationImporterWidget from './SquareLocationImporterWidget';
import { generateList } from './SquareLocationImporterWidget';

import ESquareRedirectCode from '../../interfaces/ESquareRedirectCode';

import { ISearchableChecklistItem } from '../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem';
import { useAPIV2 } from '../../yoello-lib/modules/API2/useAPIv2';
import { HTTPMethods } from '../../yoello-lib/modules/API/API';
import APIExtensions from '../../yoello-lib/modules/API2/APIDefs';
import { useUserLogout } from '../../hooks/useUserLogout';
export interface ISquareLocationImporter {
}

const useStyles = makeStyles({
    root: {
        position: "relative"
    },
    buttons: {
        position: "absolute",
        top: "0",
        right: "0",
        "& a": {
            textDecoration: "none",
        },
        "@media (max-width: 960px)": {
            position: "relative",
            display: "block",
            width: "100%",
            padding: "4px"
        }
    },
    button: {
        padding: "0.3rem 1rem",
        marginLeft: "1rem"
    }
})

const SquareLocationImporter = (props: ISquareLocationImporter) => {
    const { search } = useLocation();
    const history = useHistory();
    const classes = useStyles();
    const { t } = useTranslation();
    const { logout } = useUserLogout();
    const { squareUrl } = useSquareAuth();
    const [ csrfToken, setCsrfToken ] = useState('');
    const [ isLoading, setIsLoading ] = useState(true);
    const [ locations, setLocations ] = useState<ISearchableChecklistItem[]>([]);

    
    const { callAPI : callSquareAPI, isError: isSquareError } = useAPIV2(APIExtensions.squareLocations, {
        onMountDisabled: true
    });
    
    const code = new URLSearchParams(search).get("code");
    const redirectError = new URLSearchParams(search).get("error");
    const stateToken = new URLSearchParams(search).get("state");
    const storageToken = localStorage.getItem('square-csrf');

    useEffect(() => {
        callSquareAPI(HTTPMethods.GET, {params: {code}}).then((response: any) => {
           setIsLoading(false);
           setLocations(generateList(response.data.locations));
        }).catch((error: Error) => {
            setIsLoading(false);
            console.log(error);
        });
        //eslint-disable-next-line
    }, [code]);


    useEffect(() => {
        if(redirectError || stateToken !== storageToken){
            history.push({
                pathname: VENUE_IMPORTER_URL,
                search: `?error=${redirectError}&state=${stateToken}`
            })
        }
        //eslint-disable-next-line
    }, [redirectError]);

    useEffect(() => {
        const token = `${ESquareRedirectCode.SIGNUP}_${uuidv4()}`;
        setCsrfToken(token);
        localStorage.setItem('square-csrf', token);
    }, [])

    return (
        <div className={classes.root}>
            <div>
                <h3>{t("signup.square.select_locations")}</h3>
                    <div>
                        <div className={classes.buttons}>
                            <a 
                                href={`${squareUrl}&state=${csrfToken}`}
                                onClick={() => {setIsLoading(true)}}
                            >
                                <Button
                                    color={"default"}
                                    variant={"contained"}
                                    className={classes.button}
                                    disabled={isLoading}    
                                >
                                    {t("signup.square.reimport")}
                                    <Sync style={{width: "1.3rem", height: "1.3rem", marginLeft: "0.3rem" }} />
                                </Button>
                            </a>
                            <Button
                                color={"default"}
                                variant={"contained"}
                                className={classes.button}
                                disabled={isLoading}    
                                onClick={logout}
                            >
                                {t("signup.square.logout")}
                                <ExitToApp style={{width: "1.3rem", height: "1.3rem", marginLeft: "0.3rem" }} />
                            </Button>
                        </div>
                        <SquareLocationImporterWidget 
                            locations={locations}
                            loading={isLoading}
                            error={isSquareError}
                            onSuccess={() => {history.push(PROFILE_URL)}}
                        />
                    </div>
            </div>
        </div>
    )
}

export default SquareLocationImporter;